import { CrossOrigin, TileLayerOptions } from './../../../../../../node_modules/@types/leaflet/index.d';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'leaflet-tile-layer',
    template: '',
    standalone: false
})
export class LeafletTileLayerComponent implements TileLayerOptions {
	@Input() public name: string;
	@Input() public isDefault: boolean;
	@Input() public includeInBaseLayers: boolean = true;

	// ↓ Leaflet. ↓
	@Input() public urlTemplate: string;

	// Options.
	@Input() public minZoom: number;
	@Input() public maxZoom: number;
	@Input() public subdomains: string | string[];
	@Input() public errorTileUrl: string;
	@Input() public zoomOffset: number;
	@Input() public tms: boolean;
	@Input() public zoomReverse: boolean;
	@Input() public detectRetina: boolean;
	@Input() public crossOrigin: boolean | CrossOrigin | undefined;
	
	// Inherited from `GridLayer`.
	@Input() public keepBuffer?: number | undefined;

	// Inherited from `Layer`.
	@Input() public attribution: string;
}
